import React, { useState, useEffect } from "react";
import "./ListProduct.css";
import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import { productReducer } from "../../Redux/store";
import SlidingPane from "react-sliding-pane";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import {
  SuccessAlert,
  FailureAlert,
  InformationAlert,
  SuccessUpdate,
  FailureUpdate,
  SuccessDelete,
} from "../../components/Alert_msg/alert_msg";
function ListProduct() {
  const dispatch = useDispatch();
  const tocken = useSelector((state) => state.AccessTocken.accessTocken);
  const msToken = useSelector((state) => state.AccessTocken.o365token);
  const token = tocken ? tocken : msToken;
  const product_name = useSelector((state) => state.product.product_name);
  const product_status = useSelector((state) => state.product.product_status);
  const product_edit = useSelector((state) => state.product.product_edit);
  const product_IsPane = useSelector((state) => state.product.productIsPane);
  const isLoading = useSelector((state) => state.sidebar.apiLoad);
  const addproduct_IsPane = useSelector(
    (state) => state.product.addproductIsPane
  );
  const bu_edit = useSelector((state) => state.product.bu_edit);
  const [buData, setBuData] = useState([]);
  const [divisionData, setdivisionData] = useState([]);
  var opt = null;
  const [productData, setProductData] = useState([]);
  const [productCount, setProductCount] = useState(null);
  const [productId, setProductId] = useState(null);
  const [productName, setProductName] = useState(null);
  const [productDescription, setProductDescription] = useState(null);
  const [Editstatus, setEditStatus] = useState(null);
  const [productDivID, setproductDivID] = useState("");
  const [editDivisionId, setEditDivisionId] = useState(null);
  const [showEditBU, setShowEditBU] = useState("");
  const [showEditDivision, setShowEditDivision] = useState("");
  const [editproductDivisionId, setEditproductDivisionId] = useState(null);
  const [divisionName, setDivisionName] = useState("");
  const [businessunitName, setBusinessunitName] = useState("");
  const [statusName, setStatusName] = useState("");
  const [ProductFilter, setProductFilter] = useState("");
  const [ProductselData, setProductselData] = useState("");
  const [isFiltered, setIsFiltered] = useState(false);
  const [isFilterIReset, setIsFilterIReset] = useState(false);
  const [dummyProductfilter, setDummyProductfilter] = useState("");
  const [dummyProductselData, setDummyProducteselData] = useState("");
  const product_filter = useSelector((state) => state.product.product_filter);
  const [IsDependent, setIsDependent] = useState(false);
  // eslint-disable-next-line
  const [productUrlArray, setProductUrlArray] = useState();
  const [selectedImage, setSelectedImage] = useState();
  const [selectedImageCreate, setSelectedImageCreate] = useState();
  const [notSelectedImage, setNotSelectedImage] = useState(true);
  const [notSelectedImageCancled, setNotSelectedImageCancled] = useState(false);
  const [popUp, setPopUp] = useState(false);
  const [index1_pagenation, setIndex1_pagenation] = useState(1);
  const [index2_pagenation, setIndex2_pagenation] = useState(2);
  const [index3_pagenation, setIndex3_pagenation] = useState(3);
  const [index4_pagenation, setIndex4_pagenation] = useState(4);
  const [noOfPages, setNoOfPages] = useState(null);
  const [pageSelected, setPageSelected] = useState(1);
  // eslint-disable-next-line
  let [formValues, setFormValues] = useState(new FormData());
  // eslint-disable-next-line
  let [updateFormValues, setUpdateFormValues] = useState(new FormData());
  const [imageDetailAPI, setImageDetailAPI] = useState("");
  const [displayingNoDataIfDataEmpty, setDisplayingNoDataIfDataEmpty] =
    useState(false);
  const Add_Permission = useSelector(
    (state) => state.AccessTocken.Add_Permission
  );

  const Edit_Permission = useSelector(
    (state) => state.AccessTocken.Edit_Permission
  );
  const Delete_Permission = useSelector(
    (state) => state.AccessTocken.Delete_Permission
  );
  const View_Permission = useSelector(
    (state) => state.AccessTocken.View_Permission
  );
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);
  const listLimit = useSelector((state) => state.AccessTocken.recordsPerPage);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 4,
  };
  const options = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const onPage = {
    cursor: "pointer",
    backgroundColor: "RGB(200, 200, 200)",
    scale: "1.2",
    height: "25px",
  };
  const notOnPage = { cursor: "pointer", scale: "1" };
  const leftArrow = () => {
    if (index1_pagenation !== 1) {
      setIndex1_pagenation(index1_pagenation - 1);
      setIndex2_pagenation(index2_pagenation - 1);
      setIndex3_pagenation(index3_pagenation - 1);
      setIndex4_pagenation(index4_pagenation - 1);
    }
    setPageSelected(pageSelected - 1);
    pagenationAPi(pageSelected - 1, ProductselData, ProductFilter);
  };
  const rightArrow = () => {
    if (noOfPages >= 4) {
      if (index4_pagenation !== noOfPages) {
        setIndex1_pagenation(index1_pagenation + 1);
        setIndex2_pagenation(index2_pagenation + 1);
        setIndex3_pagenation(index3_pagenation + 1);
        setIndex4_pagenation(index4_pagenation + 1);
      }
    }
    setPageSelected(pageSelected + 1);
    pagenationAPi(pageSelected + 1, ProductselData, ProductFilter);
  };
  const leftEndArrow = () => {
    setIndex1_pagenation(1);
    setIndex2_pagenation(2);
    setIndex3_pagenation(3);
    setIndex4_pagenation(4);
    pagenationAPi(1, ProductselData, ProductFilter);
  };
  const rightEndArrow = () => {
    if (noOfPages > 4) {
      setIndex1_pagenation(noOfPages - 3);
      setIndex2_pagenation(noOfPages - 2);
      setIndex3_pagenation(noOfPages - 1);
      setIndex4_pagenation(noOfPages);
    } else if (noOfPages <= 4) {
      setIndex1_pagenation(1);
      setIndex2_pagenation(2);
      setIndex3_pagenation(3);
      setIndex4_pagenation(4);
    }
    pagenationAPi(noOfPages, ProductselData, ProductFilter);
  };
  const pagenationAPi = async (pageNo, TargetColomn, keyWord) => {
    if (!isFiltered) {
      setProductUrlArray();
      dispatch(sidebarReducer.apiLoad(true));
      setPageSelected(pageNo);
      setProductData([]);
      await axios
        .get(`masterproduct/list/?page=${pageNo}&limit=${listLimit}`, options)
        .then((response) => {
          if (response.status === 200) {
            response.data.data.rows.map(async (item, i) => {
              await fetch(item.te_productimagepath, options).then(
                async (res) => {
                  const imageBlob = await res.blob();
                  const imageObjectURL = await URL.createObjectURL(imageBlob);
                  item.te_imagObject = imageObjectURL;
                  setProductUrlArray(item.te_productimagepath);
                }
              );
            });
            dispatch(sidebarReducer.apiLoad(false));
            setProductData(response.data.data.rows);
          } else if (response.status !== 200) {
            dispatch(sidebarReducer.stringUpdate("AppDown"));
            dispatch(sidebarReducer.apiLoad(false));
          }
        })
        .catch((err) => {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
          dispatch(sidebarReducer.apiLoad(false));
        });
    } else if (isFiltered) {
      setPageSelected(pageNo);
      dispatch(sidebarReducer.apiLoad(true));
      if (!isFilterIReset) {
        setProductUrlArray();
        if (TargetColomn === "te_status") {
          let status = ProductFilter.toLowerCase();

          if (status === "active") {
            keyWord = "1";
          } else if (status === "inactive") {
            keyWord = "0";
          }
        }
        console.log(keyWord, TargetColomn);
        await axios
          .get(
            `masterproduct/list/?page=${pageNo}&limit=${listLimit}&${TargetColomn}=${keyWord}`,
            options
          )
          .then((response) => {
            console.log(response);
            dispatch(sidebarReducer.apiLoad(false));
            if (response.status === 200) {
              response.data.data.rows.map(async (item, i) => {
                await fetch(item.te_productimagepath, options).then(
                  async (res) => {
                    const imageBlob = await res.blob();
                    const imageObjectURL = await URL.createObjectURL(imageBlob);
                    item.te_imagObject = imageObjectURL;
                    await setProductUrlArray(item.te_productimagepath);
                  }
                );
              });
              setProductData(response.data.data.rows);
            } else if (response.status !== 200) {
              dispatch(sidebarReducer.apiLoad(false));
              dispatch(sidebarReducer.stringUpdate("AppDown"));
            }
          })
          .catch((err) => {
            dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          });
      } else if (isFilterIReset) {
        dispatch(sidebarReducer.apiLoad(true));
        setProductUrlArray();
        if (dummyProductselData === "te_status") {
          let status = dummyProductfilter.toLowerCase();

          if (status === "active") {
            keyWord = "1";
          } else if (status === "inactive") {
            keyWord = "0";
          }
        } else if (dummyProductselData !== "te_status") {
          keyWord = dummyProductfilter;
        }
        console.log(keyWord, dummyProductselData);
        await axios
          .get(
            `masterproduct/list/?page=${pageNo}&limit=${listLimit}&${dummyProductselData}=${keyWord}`,
            options
          )
          .then((response) => {
            if (response.status === 200) {
              dispatch(sidebarReducer.apiLoad(false));
              response.data.data.rows.map(async (item, i) => {
                await fetch(item.te_productimagepath, options).then(
                  async (res) => {
                    // const imageBlob = await res.blob();
                    // const imageObjectURL = await URL.createObjectURL(imageBlob);
                    // item.te_imagObject = imageObjectURL;
                    await setProductUrlArray(item.te_productimagepath);
                  }
                );
              });

              setProductData(response.data.data.rows);
            } else if (response.status !== 200) {
              dispatch(sidebarReducer.apiLoad(false));
              dispatch(sidebarReducer.stringUpdate("AppDown"));
            }
          })
          .catch((err) => {
            dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          });
      }
    }
  };
  async function DivisionData(opt) {
    const response = await axios.get(`division/listactive/${opt}`, options);
    return setdivisionData(response.data.data);
  }
  async function responseData() {
    dispatch(sidebarReducer.apiLoad(true));
    setProductUrlArray();
    await axios
      .get(
        `masterproduct/list?page=${pageSelected}&limit=${listLimit}`,
        options
      )
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          let pages =
            response.data.data.count === 0
              ? 1
              : Math.ceil(response.data.data.count / listLimit);
          setNoOfPages(pages);
          setProductCount(response.data.data.count);
          response.data.data.rows.map(async (item, i) => {
            // await fetch(item.te_productimagepath, options).then(async (res) => {
            //   // const imageBlob = await res.blob();
            //   // const imageObjectURL = await URL.createObjectURL(imageBlob);
            //   // item.te_imagObject = await imageObjectURL;
            //   console.log(item.te_productimagepath)
            //   await setProductUrlArray(item.te_productimagepath)
            // });
          });
          return setProductData(response.data.data.rows);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        alert(err);
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }
  async function BuResponse() {
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`businessunit/listactive`, options)
      .then((response) => {
        if (response.status === 200) {
          setBuData(response.data.data);
          dispatch(sidebarReducer.apiLoad(false));
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }
  const onAddproduct = async (e) => {
    e.preventDefault();
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .post("masterproduct/add", formValues, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          if (
            response.data.message ===
            `Product name '${formValues.get("productName")}' already exists`
          ) {
            dispatch(sidebarReducer.information(true));
          } else {
            dispatch(sidebarReducer.success(true));
          }
          dispatch(productReducer.addproduct_IsPane(false));
          responseData();
          dispatch(sidebarReducer.success(true));
          formValues.delete("productImage");
          setSelectedImageCreate();
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          // dispatch(sidebarReducer.stringUpdate("AppDown"));
          setSelectedImageCreate();
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.success(false));
        dispatch(sidebarReducer.failure(true));
        // dispatch(sidebarReducer.stringUpdate("AppDown"));
        setSelectedImageCreate();
      });
  };
  const onUpdate = (te_productid) => {
    updateFormValues.set("productName", productName);
    updateFormValues.set("productDescription", productDescription);
    updateFormValues.set("productStatus", Editstatus);
    updateFormValues.set("divisionId", editDivisionId);
    dispatch(sidebarReducer.apiLoad(true));
    axios
      .put(`masterproduct/update/${te_productid}`, updateFormValues, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          if (
            response.data.message ===
            `Product name '${updateFormValues.get(
              "productName"
            )}' already exists`
          ) {
            dispatch(sidebarReducer.information(true));
          } else {
            dispatch(sidebarReducer.success(true));
          }
          dispatch(productReducer.product_edit(false));
          dispatch(productReducer.bu_edit(false));
          dispatch(sidebarReducer.stringUpdate("ListProduct"));
          dispatch(productReducer.product_IsPane(false));
          responseData();
          updateFormValues.delete("productImage");
          setSelectedImage("");
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.update_failure(true));
        dispatch(sidebarReducer.update_success(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };
  const onDelete = (te_productid) => {
    dispatch(sidebarReducer.apiLoad(true));
    axios
      .delete(`masterproduct/delete/${te_productid}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(productReducer.product_edit(false));
          dispatch(sidebarReducer.stringUpdate("ListProduct"));
          dispatch(productReducer.product_IsPane(false));
          dispatch(sidebarReducer.delete_success(true));
          responseData();
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.success(false));
        dispatch(sidebarReducer.failure(true));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };
  async function onEdit(item) {
    await setImageDetailAPI("");
    setNotSelectedImage(true);
    dispatch(sidebarReducer.apiLoad(false));
    await axios
      .get(`masterproduct/details/${item.te_productid}`, options)
      .then((response) => {
        if (response.status === 200) {
          // fetch(response.data.data.te_productimagepath, options).then(
          //   async (res) => {
          //     const imageBlobDetail = await res.blob();
          //     const imageObjectURLDetail = await URL.createObjectURL(
          //       imageBlobDetail
          //     );

          //   }
          // );
          setImageDetailAPI(response.data.data.te_productimagepath);
          dispatch(sidebarReducer.apiLoad(false));
          setIsDependent(response.data.data.dependency);
          setProductId(response.data.data.te_productid);
          setProductName(response.data.data.te_productname);
          setProductDescription(response.data.data.te_productdescription);
          //  setProductImageURL(response.data.data.te_productimagepath);
          setEditStatus(response.data.data.te_status);
          setproductDivID(productDivID);
          setproductDivID(response.data.data.te_divisionid);
          setEditDivisionId(response.data.data.te_divisionid);
          setShowEditBU(showEditBU);
          setShowEditBU(response.data.data.te_buname);
          setShowEditDivision(showEditDivision);
          setShowEditDivision(response.data.data.te_divisionname);
          setBusinessunitName(response.data.data.te_buname);
          setDivisionName(response.data.data.te_divisionname);
          if (response.data.data.te_status === "1") {
            setStatusName(statusName);
            setStatusName("Active");
          }
          if (response.data.data.te_status === "0") {
            setStatusName("Inactive");
          }
          dispatch(productReducer.product_id(response.data.data.te_productid));
          dispatch(
            productReducer.product_name(response.data.data.te_productname)
          );
          dispatch(
            productReducer.product_description(
              response.data.data.te_productdescription
            )
          );
          dispatch(productReducer.product_status(response.data.data.te_status));
          dispatch(
            productReducer.product_image_path(
              response.data.data.te_productimagepath
            )
          );
          dispatch(
            productReducer.product_Divid(response.data.data.te_divisionid)
          );
          dispatch(productReducer.product_IsPane(true));
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.success(false));
        dispatch(sidebarReducer.failure(true));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }
  const onCancel = () => {
    setProductName(product_name);
    setEditStatus(product_status);
    dispatch(productReducer.product_edit(false));
    dispatch(productReducer.bu_edit(false));
  };
  useEffect(() => {
    if (View_Permission === 1) {
      responseData(opt);
      BuResponse();
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleSearch = async (e, TargetColomn, keyWord) => {
    console.log(keyWord);
    e.preventDefault();
    setProductUrlArray();
    dispatch(sidebarReducer.apiLoad(true));
    if (TargetColomn === "te_status") {
      if (keyWord === "active") {
        keyWord = "1";
      } else if (keyWord === "Active") {
        keyWord = "1";
      } else if (keyWord === "inactive") {
        keyWord = "0";
      }
    }
    await axios
      .get(
        `masterproduct/list?page=${pageSelected}&limit=${listLimit}&${TargetColomn}=${keyWord}`,
        options
      )
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          response.data.data.rows.map(async (item, i) => {
            setProductUrlArray(item.te_imagObject);
          });

          setProductData(response.data.data.rows);
          setProductCount(response.data.data.count);
          let pages =
            response.data.data.count === 0
              ? 1
              : Math.ceil(response.data.data.count / listLimit);
          setNoOfPages(pages);
          dispatch(productReducer.product_filter(false));
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.success(false));
        dispatch(sidebarReducer.failure(true));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };
  const handleReset = () => {
    dispatch(productReducer.product_filter(true));
    setProductFilter("");
    setProductselData("");
    responseData();
  };
  const handleReset1 = (e) => {
    setProductFilter("");
    setProductselData("");
  };
  const [selectedFileName, setSelectedFileName] = useState(
    "Upload logo or image of the product"
  );

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFileName(file.name);
      formValues.set("productImage", file);
      setSelectedImageCreate(file);
    } else {
      setSelectedFileName("Upload logo or image of the product");
    }
  };

  return (
    <div>
      {View_Permission === 1 ? (
        <div className="Image container-fluid">
          <div className="row p-0">
            <div className="col-12 p-0">
              <div className="row shadow g-0 p-0">
                <div className="col">
                  <div
                    className="g-0 m-0 border-top"
                    style={{ backgroundColor: "#f2f3f5" }}
                  >
                    <div className="row p-0">
                      <div className="col-6" style={{ height: "50px" }}>
                        <div className="d-flex flex-row">
                          <div
                            className="pt-2 mt-1"
                            style={{ paddingLeft: "28px" }}
                          >
                            <h5>
                              <strong>Products</strong>
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-6" style={{ height: "50px" }}>
                        <div className="d-flex flex-row-reverse me-3">
                          <div
                            className="p-2"
                            style={{ cursor: "not-allowed" }}
                          >
                            <button
                              className="btn add-button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-expanded="false"
                              aria-controls="collapseOne"
                              //  disabled...........................
                              style={{
                                backgroundColor: "white",
                                minWidth: "150px",
                              }}
                              onClick={() => {
                                Add_Permission === 1 &&
                                  dispatch(
                                    productReducer.addproduct_IsPane(true)
                                  );
                                handleReset();
                              }}
                            >
                              <span
                                className="ToolTipU"
                                // style={{
                                //   backgroundColor: "white",
                                // }}
                              >
                                <i className="bi bi-plus-lg"></i>&nbsp; Add
                                Product
                                <span
                                  className="ToolTipTextU"
                                  style={{
                                    backgroundColor:
                                      Add_Permission === 1 ? "white" : "white",
                                    border:
                                      Add_Permission === 1
                                        ? "1px solid black"
                                        : "red",
                                    color:
                                      Add_Permission === 1 ? "black" : "white",
                                  }}
                                >
                                  {Add_Permission === 1
                                    ? "Add new Product."
                                    : "You do not have a permission"}
                                </span>
                              </span>
                            </button>
                          </div>
                          <div className="dropdown  p-2">
                            {product_filter ? (
                              <button
                                type="button"
                                className="btn btn px-2 "
                                style={{
                                  backgroundColor: "white",
                                  minWidth: "77px",
                                }}
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                                onClick={(e) => {
                                  setDisplayingNoDataIfDataEmpty(true);
                                  handleSearch(
                                    e,
                                    ProductselData,
                                    ProductFilter.toLowerCase()
                                  );
                                }}
                              >
                                <i className="bi bi-funnel-fill iconcolor"></i>
                                &nbsp; <span className="fw-normal">Filter</span>
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn px-2 "
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                                style={{ backgroundColor: "white" }}
                                onClick={() => {
                                  setDisplayingNoDataIfDataEmpty(false);
                                  handleReset();
                                  setIsFiltered(false);
                                }}
                              >
                                <i className="bi bi-funnel-fill iconcolor"></i>
                                &nbsp;
                                <span className="fw-normal">Clear</span>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row g-0 p-0" style={{ minHeight: "100vh" }}>
                <div className="col">
                  <div className="">
                    {!product_IsPane && !addproduct_IsPane && (
                      <div className="accordion" id="accordionExample">
                        <div
                          id="collapseOne"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div
                            className="row accordion-body d-flex align-items-end p-2"
                            style={{
                              backgroundColor: "#00ca431c",
                              height: "90px",
                            }}
                          >
                            <div className="container">
                              <div className="row justify content start">
                                <div
                                  className="col-3"
                                  style={{
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <TextField
                                    label="keyword"
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                      "& > :not(style)": {
                                        zIndex: "0",
                                      },
                                    }}
                                    value={ProductFilter}
                                    onChange={(e) => {
                                      let val = e.target.value;

                                      setProductFilter(val);
                                      setDummyProductfilter(val);
                                    }}
                                  />
                                </div>
                                <div
                                  className="col-3"
                                  style={{
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <FormControl sx={{ width: "90%" }}>
                                    <InputLabel
                                      id="demo-simple-select-label"
                                      style={{ zIndex: "0" }}
                                      size="small"
                                    >
                                      Target Column
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      label="Target Columns"
                                      value={ProductselData}
                                      size="small"
                                      onChange={(e) => {
                                        let val = e.target.value;
                                        setProductselData(val);
                                        setDummyProducteselData(val);
                                      }}
                                    >
                                      <MenuItem value="te_productname">
                                        Product Name
                                      </MenuItem>
                                      <MenuItem value="te_productdescription">
                                        Description
                                      </MenuItem>
                                      <MenuItem value="te_status">
                                        Status
                                      </MenuItem>
                                      <MenuItem value="te_divisionname">
                                        Division
                                      </MenuItem>
                                      <MenuItem value="te_buname">
                                        Busniness Unit
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </div>

                                <div
                                  className="col-2"
                                  style={{
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <button
                                    className="btn add-button text-white "
                                    style={{
                                      backgroundColor: "var(--themes-color)",
                                      height: "40px",
                                      width: "70px",
                                    }}
                                    onClick={(e) => {
                                      handleSearch(
                                        e,
                                        ProductselData,
                                        ProductFilter.toLowerCase()
                                      );
                                      setIsFiltered(true);
                                      setIsFilterIReset(false);
                                      setPageSelected(1);
                                    }}
                                    disabled={
                                      ProductFilter.length > 0 &&
                                      ProductselData.length > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Filter
                                  </button>
                                </div>

                                <div
                                  className="col-2"
                                  style={{
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <button
                                    className="btn text-white"
                                    style={{
                                      backgroundColor: "var(--themes-color)",
                                      height: "40px",
                                      width: "70px",
                                    }}
                                    onClick={() => {
                                      handleReset1();
                                      setIsFilterIReset(true);
                                    }}
                                    disabled={
                                      ProductFilter.length > 0 &&
                                      ProductselData.length > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {displayingNoDataIfDataEmpty &&
                      productData.length === 0 && (
                        <h6
                          style={{
                            marginLeft: "500px",
                            marginTop: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          No Data Found
                        </h6>
                      )}
                    {!apiLoad ? (
                      <div className="ContentCardMain">
                      {productData.map((item, index) => {
  // Helper function to get initials from product name
  const getInitials = (name) => {
    if (!name) return 'P'; // Default to 'P' for Product if no name
    
    // Handle cases with underscores or camelCase
    let processedName = name;
    
    // Replace underscores with spaces and split camelCase
    processedName = name
      .replace(/_/g, ' ') // Replace underscores with spaces
      .replace(/([a-z])([A-Z])/g, '$1 $2'); // Split camelCase (e.g., ActiveDiesel -> Active Diesel)
    
    return processedName
      .split(' ')
      .filter(word => word.length > 0) // Remove empty strings
      .map(word => word.charAt(0).toUpperCase())
      .slice(0, 2) // Take only first 2 initials
      .join('');
  };

  return (
    <div
      className="ms-5 mt-5"
      style={{
        paddingLeft: "0px",
        display: "flex",
        flexWrap: "wrap",
      }}
      key={index}
      onClick={() => {
        console.log("clicked card", item);
        onEdit(item);
        handleReset();
      }}
    >
      <div
        className="p-0 d-flex flex-row card shadow-sm mb-3"
        style={{
          cursor: "pointer",
          height: "125px",
          maxWidth: "260px",
          minWidth: "259px",
          border: "1px solid green",
        }}
      >
        <div
          className="col-7"
          style={{ borderRight: "1px solid green" }}
        >
          <div className="d-flex flex-column bd-highlight mb-3">
            <div
              className="bd-highlight"
              style={{
                backgroundColor: "#009900",
                borderRadius: "5px 0 0 0",
              }}
            >
              <span className="ToolTipP">
                <h5
                  className="m-0 pt-2 ps-2"
                  style={{
                    color: "#f2f3f5",
                    fontSize: "1.2rem",
                  }}
                >
                  <strong>{item.te_productname}</strong>
                </h5>
                <span className="ToolTipTextP">
                  Product Name
                </span>
              </span>
            </div>
            <div
              className="bd-highlight"
              style={{
                backgroundColor: "#009900",
              }}
            >
              <span className="ToolTipP">
                <h6
                  style={{
                    color: "white",
                    fontSize: "0.7rem",
                    paddingTop: "8px",
                    paddingLeft: "8px",
                  }}
                >
                  {item.te_buname} /{item.te_divisionname}
                </h6>
                <span className="ToolTipTextP">
                  Business Unit/ Division
                </span>
              </span>
            </div>
            <hr
              className="m-0"
              style={{
                marginTop: "2px",
                marginBottom: "2px",
              }}
            />
            <div className="p-2 bd-highlight">
              <span className="ToolTipP">
                <p
                  className="m-0"
                  style={{
                    fontSize: "0.7rem",
                  }}
                >
                  {item.te_productdescription}
                </p>
                <span className="ToolTipTextP">
                  Product Description
                </span>
              </span>
            </div>
          </div>
        </div>
        <div
          className="col"
          style={{
            position: "relative",
            overflow: "hidden",
            width: "107px",
            height: "125px",
          }}
        >
          {/* Image with fallback to initials */}
          <img
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              right: "0px",
              borderRadius: "0px 5px 5px 0",
              objectFit: "contain",
            }}
            src={item.te_productimagepath}
            alt={item.te_productname}
            onError={(e) => {
              // Hide the image and show initials fallback
              e.target.style.display = 'none';
              const initialsDiv = e.target.nextElementSibling;
              if (initialsDiv) {
                initialsDiv.style.display = 'flex';
              }
            }}
            onLoad={(e) => {
              // If image loads successfully, hide initials fallback
              const initialsDiv = e.target.nextElementSibling;
              if (initialsDiv) {
                initialsDiv.style.display = 'none';
              }
            }}
          />
          {/* Initials fallback */}
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              right: "0px",
              borderRadius: "0px 5px 5px 0",
              backgroundColor: "rgba(0, 153, 0, 0.27)",
              display: "none", // Initially hidden
              alignItems: "center",
              justifyContent: "center",
              fontSize: "2rem",
              fontWeight: "bold",
              color: "white",
              textShadow: "0 1px 2px rgba(0,0,0,0.3)"
            }}
          >
            {getInitials(item.te_productname)}
          </div>
        </div>
      </div>
    </div>
  );
})}
                      </div>
                    ) : (
                      <div
                        style={{
                          height: "80vh",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div className="spinnerApi"></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row main-footer">
                <div className="col-3 mt-2" style={{ whiteSpace: "nowrap" }}>
                  Total Records: {productCount}
                </div>
                <div className="col-4 mt-2">
                  <div className="d-flex justify-content-center ">
                    <div className={noOfPages > 4 ? "" : ""}>
                      <i
                        className="bi bi-chevron-double-left"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          leftEndArrow();
                        }}
                      ></i>
                    </div>
                    <div className={noOfPages > 4 ? "" : ""}>
                      <i
                        className="bi bi-chevron-left"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          pageSelected !== 1 && leftArrow();
                        }}
                      ></i>
                    </div>
                    <div
                      className={
                        noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                      }
                      style={
                        index1_pagenation === pageSelected ? onPage : notOnPage
                      }
                      onClick={() => {
                        pagenationAPi(
                          index1_pagenation,
                          ProductselData,
                          ProductFilter.toLowerCase()
                        );
                      }}
                    >
                      {index1_pagenation}
                    </div>
                    {noOfPages > 1 && (
                      <div
                        className={
                          noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                        }
                        style={
                          index2_pagenation === pageSelected
                            ? onPage
                            : notOnPage
                        }
                        onClick={() => {
                          pagenationAPi(
                            index2_pagenation,
                            ProductselData,
                            ProductFilter.toLowerCase()
                          );
                        }}
                      >
                        {index2_pagenation}
                      </div>
                    )}
                    {noOfPages > 2 && (
                      <div
                        className={
                          noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                        }
                        style={
                          index3_pagenation === pageSelected
                            ? onPage
                            : notOnPage
                        }
                        onClick={() => {
                          pagenationAPi(
                            index3_pagenation,
                            ProductselData,
                            ProductFilter.toLowerCase()
                          );
                        }}
                      >
                        {index3_pagenation}
                      </div>
                    )}
                    {noOfPages > 3 && (
                      <div
                        className={
                          noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                        }
                        style={
                          index4_pagenation === pageSelected
                            ? onPage
                            : notOnPage
                        }
                        onClick={() => {
                          pagenationAPi(
                            index4_pagenation,
                            ProductselData,
                            ProductFilter.toLowerCase()
                          );
                        }}
                      >
                        {index4_pagenation}
                      </div>
                    )}
                    <div className={noOfPages > 4 ? "" : ""}>
                      <i
                        className="bi bi-chevron-right"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          pageSelected !== noOfPages && rightArrow();
                        }}
                      ></i>
                    </div>
                    <div className={noOfPages > 4 ? "" : ""}>
                      <i
                        className="bi bi-chevron-double-right"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          rightEndArrow();
                        }}
                      ></i>
                    </div>
                  </div>
                </div>
                <div className="col-3 mt-2 ">
                  <div className="d-flex justify-content-end me-3">
                    <span>
                      <strong>Page {pageSelected} </strong> of{" "}
                      <strong>{noOfPages}</strong>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {
            <SlidingPane
              className="some-custom-class"
              overlayClassName="some-custom-overlay-class"
              width="67%"
              hideHeader
              isOpen={product_IsPane}
              onRequestClose={() => {
                onCancel();
              }}
            >
              <div
                className="container-fluid m-0 g-0 border"
                style={{ backgroundColor: "#f2f3f5" }}
              >
                <div
                  className="row p-0 align-items-center"
                  style={{ height: "54px" }}
                >
                  <div className="col-3">
                    <div className="d-flex align-items-center flex-row">
                      <div
                        className="px-2 my-1"
                        onClick={() => {
                          dispatch(productReducer.product_edit(false));
                          dispatch(sidebarReducer.stringUpdate("ListProduct"));
                          dispatch(productReducer.product_IsPane(false));
                          dispatch(productReducer.bu_edit(false));
                          setNotSelectedImage(true);
                          setNotSelectedImageCancled(false);
                          setSelectedImage();
                        }}
                        style={{
                        cursor: "pointer",
  minHeight: "32px",
    minWidth: "32px",
    fontSize: "16px"}}
                      >
                        ←
                      </div>
                      <div className="px-2 pt-2 pb-1 border-secondary border-opacity-25 border-start">
                        <h5>
                          <strong>{product_name}</strong>
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-9">
                    <div className="d-flex align-items-center flex-row-reverse">
                      <div
                        className="me-0 border-start border-end"
                        style={{ height: "55px" }}
                      >
                        {product_edit ? (
                          <button
                            className="button"
                            style={{
                              paddingTop: "3px",
                              border: "none",
                              height: "55px",
                            }}
                            onClick={() => onUpdate(productId)}
                          >
                            <i className="bi bi-file-earmark-diff-fill"></i>
                            &nbsp;Save Changes
                          </button>
                        ) : (
                          <button
                            className="button"
                            style={{
                              zIndex: "1100",
                              paddingTop: "3px",
                              border: "none",
                              height: "55px",
                            }}
                            onClick={() =>
                              Edit_Permission === 1 &&
                              dispatch(
                                productReducer.product_edit(!product_edit)
                              )
                            }
                          >
                            <span className="ToolTipPEdit">
                              <i className="bi bi-pencil-fill"></i>&nbsp; Edit
                              Record
                              <span
                                className="ToolTipTextPEdit"
                                style={{
                                  backgroundColor:
                                    Edit_Permission === 1
                                      ? "var(--themes-color)"
                                      : "red",
                                }}
                              >
                                {Edit_Permission === 1
                                  ? "You can edit the Product."
                                  : "You cannot edit the Product."}
                              </span>
                            </span>
                          </button>
                        )}
                      </div>
                      {product_edit && (
                        <div
                          className="px-0 border-start border-end"
                          onClick={onCancel}
                          style={{ height: "55px" }}
                        >
                          <button
                            className="button"
                            style={{
                              paddingTop: "3px",
                              border: "none",
                              height: "55px",
                            }}
                          >
                            <i className="bi bi-arrow-clockwise"></i>
                            &nbsp;Cancel Changes
                          </button>
                        </div>
                      )}
                      <div
                        className="border-start border-end "
                        style={{ height: "55px" }}
                      >
                        <button
                          className="button"
                          // data-bs-toggle="modal"
                          data-bs-target="#DeleteUser"
                          // data-backdrop="false"
                          style={{
                            zIndex: "1100",
                            paddingTop: "3px",
                            border: "none",
                            height: "55px",
                          }}
                          onClick={() => {
                            Delete_Permission === 1 && setPopUp(true);
                          }}
                        >
                          <span className="ToolTipPEdit">
                            <i className="bi bi-trash-fill"></i>&nbsp; Delete
                            record
                            <span
                              className="ToolTipTextPEdit"
                              style={{
                                backgroundColor:
                                  Delete_Permission === 1
                                    ? "var(--themes-color)"
                                    : "red",
                              }}
                            >
                              {Delete_Permission === 1
                                ? "You can delete the Product."
                                : "You cannot delete the Product."}
                            </span>
                          </span>
                        </button>
                      </div>
                      <div className="p-2">
                        <i>
                          <strong style={{ color: "blue" }}>
                            {product_edit ? "Edit Mode" : "View Mode"}
                          </strong>
                        </i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="row contentscroll"
                style={{ width: "101.5%", marginLeft: "0px" }}
              >
                <div className="col ms-3 mt-2">
                  <div className="mt-2" style={{ width: "98%" }}>
                    <div className="mb-3">
                      <TextField
                        type="text"
                        className="form-control"
                        id="formGroupExampleInput"
                        label="Name"
                        variant="outlined"
                        size="small"
                        value={productName}
                        onChange={(e) => {
                          let val = e.target.value;
                          setProductName(val);
                        }}
                        disabled={product_edit ? false : true}
                        sx={{
                          // Root class for the input field
                          "& .MuiOutlinedInput-root": {
                            color: "#000",
                            fontFamily: "Arial",

                            // Class for the border around the input field
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderWidth: "2px",
                            },
                          },
                          // Class for the label of the input field
                          "& .MuiInputLabel-outlined": {
                            color: "#2e2e2e",
                          },
                        }}
                      />
                    </div>
                    <div className="mb-3">
                      <TextField
                        type="text"
                        className="form-control"
                        id="formGroupExampleInput"
                        label="Descripition"
                        variant="outlined"
                        size="small"
                        value={productDescription}
                        onChange={(e) => {
                          let val = e.target.value;
                          setProductDescription(val);
                        }}
                        disabled={product_edit ? false : true}
                      />
                    </div>
                    <div
                      className="mb-3"
                      onMouseDown={() => {
                        if (product_edit) setStatusName("Status");
                      }}
                    >
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label" size="small">
                          {statusName}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          disabled={product_edit ? false : true}
                          label="inactiv"
                          variant="outlined"
                          size="small"
                          onChange={(e) => {
                            let val = e.target.value;
                            setEditStatus(val);
                          }}
                        >
                          <MenuItem
                            value="1"
                            onClick={() => {
                              setStatusName("Status");
                            }}
                          >
                            Active
                          </MenuItem>
                          <MenuItem
                            value="0"
                            onClick={() => {
                              setStatusName("Status");
                            }}
                          >
                            Inactive
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    {/* <div
                      className="mb-3"
                      onMouseDown={() => {
                        if (product_edit) setBusinessunitName("Business Unit");
                      }}
                    >
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label" size="small">
                          {businessunitName}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          label="Business Unit"
                          variant="outlined"
                          disabled={product_edit ? false : true}
                          onChange={(e) => {
                            dispatch(productReducer.bu_edit(true));
                            let val = e.target.value;
                            DivisionData(val);
                          }}
                        >
                          {buData.map((item, index) => (
                            <MenuItem
                              key={index}
                              value={item.te_buid}
                              onClick={() => {
                                setBusinessunitName("Business Unit");
                              }}
                            >
                              {item.te_buname}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div> */}
                    {/* <div
                      className="mb-3"
                      onMouseDown={() => {
                        if (product_edit && bu_edit)
                          setBusinessunitName("Business Unit");
                      }}
                    >
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label" size="small">
                          {divisionName}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Division"
                          // InputLabelProps={{ shrink: true }}
                          disabled={bu_edit ? false : true}
                          variant="outlined"
                          size="small"
                          onChange={(e) => {
                            let val = e.target.value;
                            setEditproductDivisionId(editproductDivisionId);
                            setEditproductDivisionId(val);
                            setEditDivisionId(val);
                          }}
                        >
                          {divisionData.map((item, index) => (
                            <MenuItem
                              key={index}
                              value={item.te_divisionid}
                              onClick={() => {
                                setDivisionName("Division");
                              }}
                            >
                              {item.te_divisionname}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div> */}
                    <div className="mb-3">
                      <form>
                        <input
                          type="file"
                          className="form-control"
                          style={{
                            marginTop: "0px",
                          }}
                          accept=".png, .jpg, .jpeg"
                          onChange={(e) => {
                            setSelectedImage(e.target.files[0]);
                            setNotSelectedImage(false);
                            let val = e.target.files[0];
                            updateFormValues.set("productImage", val);
                            if (val === undefined) {
                              return setNotSelectedImageCancled(true);
                            } else if (val === null) {
                              return setNotSelectedImageCancled(true);
                            } else {
                              return setNotSelectedImageCancled(false);
                            }
                          }}
                          disabled={product_edit ? false : true}
                        />
                      </form>
                    </div>
                    <div className="mb-3">
                      {notSelectedImage && (
                        <img
                          style={{ width: "500px" }}
                          src={imageDetailAPI}
                          alt="error"
                        />
                      )}
                      {notSelectedImageCancled && (
                        <img
                          style={{ width: "500px" }}
                          src={imageDetailAPI}
                          alt="error"
                        />
                      )}
                      {selectedImage && (
                        <div>
                          <img
                            style={{ width: "500px" }}
                            src={URL.createObjectURL(selectedImage)}
                            alt="loading..."
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </SlidingPane>
          }
          <SlidingPane
            className="some-custom-class"
            overlayClassName="some-custom-overlay-class"
            width="67%"
            hideHeader
            isOpen={addproduct_IsPane}
            onRequestClose={() => {}}
          >
            <div
              className="container-fluid m-0 g-0 border"
              style={{ backgroundColor: "#f2f3f5" }}
            >
              <div
                className="row p-0 align-items-center"
                style={{ height: "54px" }}
              >
                <div className="col-3">
                  <div className="d-flex align-items-center flex-row">
                    <div
                      className="px-2 my-1"
                      onClick={() => {
                        dispatch(sidebarReducer.stringUpdate("ListProduct"));
                        dispatch(productReducer.addproduct_IsPane(false));
                        setSelectedImageCreate();
                      }}
                      style={{
                        cursor: "pointer",
  minHeight: "32px",
    minWidth: "32px",
    fontSize: "16px"}}
                    >
                       ←
                      
                    </div>
                    <div className="px-2 pt-2 pb-1 border-secondary border-opacity-25 border-start">
                      <h5>
                        <strong>Add Product</strong>
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-9"></div>
              </div>
            </div>
            <div
              className="row contentscroll"
              style={{ width: "101.5%", marginLeft: "0px" }}
            >
              <div className="col ms-3 mt-2">
                <form
                  onSubmit={onAddproduct}
                  className="ps-3 py-3 pe-3"
                  style={{ width: "98%" }}
                >
                  <div className="mb-3">
                    <TextField
                      type="text"
                      className="form-control mt-2"
                      id="formGroupExampleInput"
                      label="Name"
                      variant="outlined"
                      size="small"
                      required
                      onChange={(e) => {
                        let val = e.target.value;
                        formValues.set("productName", val);
                        // setNewProduct(val);
                      }}
                    />
                  </div>
                  <div className="mb-3">
                    <TextField
                      type="text"
                      className="form-control"
                      id="formGroupExampleInput"
                      label="Descripition"
                      variant="outlined"
                      size="small"
                      required
                      onChange={(e) => {
                        let val = e.target.value;
                        formValues.set("productDescription", val);
                        // setProductDescripition(val);
                      }}
                    />
                  </div>
                  <div>
                    <div className="mb-3">
                      <FormControl fullWidth>
                        <InputLabel
                          id="demo-simple-select-label"
                          size="small"
                          required
                        >
                          Status
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          required
                          size="small"
                          label="inactiv"
                          variant="outlined"
                          onChange={(e) => {
                            let val = e.target.value;
                            formValues.set("productStatus", val);
                            // setNewStatus(val);
                          }}
                          className="custom-select"
                        >
                          <MenuItem value="1">Active</MenuItem>
                          <MenuItem value="0">Inactive</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  {/* <div className="mb-3">
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-simple-select-label"
                        size="small"
                        required
                      >
                        Businiess Unit
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        size="small"
                        label="Businiess Unit"
                        variant="outlined"
                        onChange={(e) => {
                          let val = e.target.value;
                          DivisionData(val);
                        }}
                      >
                        {buData.map((item, index) => (
                          <MenuItem key={index} value={item.te_buid}>
                            {item.te_buname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div> */}
                  {/* <div className="mb-3">
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-simple-select-label"
                        size="small"
                        required
                      >
                        Division
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Division"
                        variant="outlined"
                        size="small"
                        required
                        onChange={(e) => {
                          let val = e.target.value;
                          formValues.set("divisionId", val);
                          // setNewDivId(val);
                        }}
                      >
                        {divisionData.map((item, index) => (
                          <MenuItem key={index} value={item.te_divisionid}>
                            {item.te_divisionname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div> */}
                  <div className="mb-3">
                    <div>
                      <input
                        type="file"
                        className="form-control"
                        title="Choose an image of the product or logo."
                        style={{
                          marginTop: "0px",
                        }}
                        accept=".png, .jpg, .jpeg"
                        onChange={(e) => {
                          setSelectedImageCreate(e.target.files[0]);
                          let val = e.target.files[0];
                          formValues.set("productImage", val);
                          if (val === null || val === undefined) {
                            return setSelectedImageCreate();
                          }
                        }}
                      />
                    </div>
                  </div>
                  {selectedImageCreate && (
                    <div className="mb-3">
                      <img
                        style={{
                          position: "relative",
                          width: "500px",
                          height: "250px",
                        }}
                        src={URL.createObjectURL(selectedImageCreate)}
                        alt="loading..."
                      />
                    </div>
                  )}
                  <div
                    className="mb-5 d-flex align-items-center"
                    style={{ gap: "1rem" }}
                  >
                    <button
                      className="btn btn-light text-white"
                      type="submit"
                      style={{ backgroundColor: "var(--themes-color)" }}
                    >
                      &nbsp;Submit
                    </button>
                    {isLoading && <div className="spinnerC"></div>}
                  </div>
                </form>
              </div>
            </div>
          </SlidingPane>
          <Modal
            open={popUp}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <center>
                <div
                  style={{
                    overflowY: "auto",
                  }}
                >
                  <h6>
                    {IsDependent
                      ? " This Product has dependency, Cannot delete this Product"
                      : "Are you sure you want to delete this Product?"}
                  </h6>
                </div>

                <div className="pt-4">
                  {!IsDependent && (
                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      style={{
                        width: "100px",
                      }}
                      onClick={() => {
                        setPopUp(false);
                        onDelete(productId);
                      }}
                    >
                      Delete
                    </button>
                  )}
                  &nbsp; &nbsp; &nbsp;
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    style={{
                      width: "100px",
                    }}
                    onClick={() => {
                      setPopUp(false);
                    }}
                  >
                    Close
                  </button>
                </div>
              </center>
            </Box>
          </Modal>
          <SuccessAlert />
          <FailureAlert />
          <InformationAlert />
          <SuccessUpdate />
          <FailureUpdate />
          <SuccessDelete />
        </div>
      ) : (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "red",
          }}
        >
          <h3>You do not have permission to view this page.</h3>
        </div>
      )}
    </div>
  );
}

export default ListProduct;
